import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, A B Ghule Enterprises, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | A B Ghule Enterprises | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="A B Ghule Enterprises" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "A B Ghule Enterprises - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend A B Ghule Enterprises for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, A B Ghule Enterprises, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>Privacy Policy</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At A B Ghule Enterprises, we value your trust and are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>
                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  We collect personal information like name, contact details, payment information, and travel preferences to provide our services effectively.
                </p>

                <p className="highlight darkcolor">2. Usage Data:</p>
                <p>
                  We gather information about your interaction with our website or app, including IP address, device details, and browsing patterns.
                </p>

                <p className="highlight darkcolor">3. Location Data:</p>
                <p>
                  With your permission, we collect location data to enhance location-based services and improve user experiences.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>
                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  Your information helps us confirm bookings, process payments, and provide seamless cab services.
                </p>

                <p className="highlight darkcolor">2. Enhancing User Experience:</p>
                <p>
                  We analyze user data to improve our offerings, resolve issues, and develop new features.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We use your contact details to share booking confirmations, service updates, and promotional offers.
                </p>

                <p className="highlight darkcolor">4. Marketing:</p>
                <p>
                  With your consent, we may send exclusive deals and updates about our services via email or SMS.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>
                <p className="highlight darkcolor">1. Third-Party Partners:</p>
                <p>
                  We may share your details with trusted partners to support operations such as payment processing or customer support.
                </p>

                <p className="highlight darkcolor">2. Legal Requirements:</p>
                <p>
                  Information may be disclosed to comply with legal obligations or protect our rights and safety.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement strict security measures to safeguard your data but cannot guarantee absolute security against all threats.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can access, update, or delete your data anytime. Opt-out options for promotional communications are also available.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  This policy is subject to updates. Changes will be effective upon posting on our website, and we recommend reviewing it regularly.
                </p>
              </div>
            </div>

            <div className='col-12 col-md-5'>
              <div className="image-container">
                <img src="/images/privacy-policy.jpg" className="bg-cover" alt="Privacy Policy" />
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any queries regarding our privacy policy, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918624029699">+91 8624029699</a></li>
              <li><b>Email:</b> <a href="mailto:booking@abghulecabs.com">booking@abghulecabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
